<template>
	<div id="tribeid">
		<div id="home">
			<!-- top navigation -->
			<Navigation />

			<!------------- HERO IMAGE SECTION -------->
			<div
				id="banner"
				class="d-flex flex-wrap align-items-center justify-content-center"
			>
				<div class="container-fluid">
					<div class="row align-content-center m-0 p-0">
						<div class="col-12 hero-text">
							<!-- <div class="container"> -->
							<div class="row justify-content-center">
								<div class>
									<h2>A public digital good that ensures that the net of AfCFTA</h2>
									<h2>benefites does not miss any African enterprise</h2>
								
								</div>
							</div>
							<div
								class="row justify-content-center center-buttons"
							>
								<div
									class="col-lg-4 col-md-5 col-xs-11 col-sm-11 mt-4"
								>
									<a href="#about" class="btn btn-light"
										>Read More</a
									>
								</div>
							</div>
							<div
								class="row justify-content-center logo-content"
							>
								<div class="col-4 col-lg-3 col-md-3">
									<img
										class="img-fluid"
										src="../assets/D.png"
										alt
									/>
								</div>
								<div class="col-4 col-lg-3 col-md-3">
									<img
										class="img-fluid"
										src="../assets/E.png"
										alt
									/>
								</div>
							</div>
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- ABOUT -->
		<About />
		<!-- Why signup-->
		<HowItWorks />
		<!-- Why TribeId -->
		<!-- <TribeId /> -->
		<!-- Contact -->
		<Contact />
		<!-- Footer -->
		<Footer />
	</div>
</template>

<script>
import Navigation from "../components/Navigation.vue";
import About from "../components/About.vue";
// import TribeId from "../components/TribeId.vue";
import HowItWorks from '../components/HowItWorks'
import Contact from "../components/Contact.vue";
import Footer from "../components/Footer.vue";
export default {
	components: {
		Navigation: Navigation,
		About: About,
		HowItWorks:HowItWorks,
		Contact: Contact,
		Footer: Footer,
	},
};
</script>
<style scoped>
.center-buttons a {
	width: 100%;
	padding: 10px 0;
}
#tribeid {
	height: 100%;
	width: 100%;
}
#home {
	background: #ba2428;
	background-image: url("../assets/hero.jpg");
	width: 100%;
	height: 100%;
	background-attachment: fixed;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}

#banner {
	height: 100%;
	padding-top: 100px;
}
#banner h2 {
	color: #fff;
	/* font-size: 4em; */
	font-weight: 600;
}
#banner p {
	margin: 40px;
}
.button {
	background-color: #fff;
	color: #ba2428;
	text-decoration: none;
	padding: 10px 20px;
}
.button:hover {
	background-color: #f5f5f5;
	text-decoration: underline;
}
.logo-content {
	margin-top: 50px;
}
.hero-text{
	margin-top:100px;
}
@media screen and (max-width:600px) {
	#banner{
		padding-top:0px;
	}
}
</style>
